import { GoogleAnalyticsEscriptEventName } from '@/hooks/analytics/types';
import useGoogleAnalytics from '@/hooks/analytics/useGoogleAnalytics';
import { emitUIEvent } from '@montugroup/data-collection';
import { Divider, Typography } from '@montugroup/design-system';
import { useEffect } from 'react';
import { ResendInviteButton } from '../ResendInviteButton';

export const DuplicateTokenPendingInvite = () => {
  const { sendGoogleAnalyticsEvent } = useGoogleAnalytics();

  useEffect(() => {
    sendGoogleAnalyticsEvent(GoogleAnalyticsEscriptEventName.PRESCRIPTION_SUBMIT_ALREADY_ATTACHED, {});
    // todo: emitUIEvent is an interim approach until the data collection package is updated with 'Data Events' schema
    emitUIEvent(
      {
        component_name: 'duplicate_token_pending_invite_screen',
        event_name: 'screenViewed',
        id: 'escript_onboarding_duplicate_token_pending_invite',
        value: 'duplicate token pending invite screen viewed',
      },
      [],
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Typography variant="subtitle1" fontWeight={600}>
        Welcome back!
      </Typography>
      <Typography data-testid="customer-escript-duplicate-token-pending-invite">
        Looks like you&apos;ve already submitted this script! Use the invitation in your email or mobile to sign up with
        us.
      </Typography>
      <Divider />
      <Typography variant="body2">
        Didn&apos;t get the invite? <ResendInviteButton />
      </Typography>
    </>
  );
};
